export const LabelsDocsSettingsActionTypes = {
    API_RESPONSE_SUCCESS: '@@labels-docs-settings/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@labels-docs-settings/API_RESPONSE_ERROR',
    GET_LABELS_DOCS_SETTINGS: '@@labels-docs-settings/GET_LABELS_DOCS_SETTINGS',
    UPDATE_LABELS_DOCS_SETTINGS: '@@labels-docs-settings/UPDATE_LABELS_DOCS_SETTINGS',
    UPDATE_LABELS_DOCS_SETTINGS_SUCCESS: '@@labels-docs-settings/UPDATE_LABELS_DOCS_SETTINGS_SUCCESS',
    UPDATE_LABELS_DOCS_SETTINGS_ERROR: '@@labels-docs-settings/UPDATE_LABELS_DOCS_SETTINGS_ERROR',
    UPDATE_LABELS_DOCS_SETTINGS_RESET: '@@labels-docs-settings/UPDATE_LABELS_DOCS_SETTINGS_RESET',
};
